export type DistanceUnit = 'nmi' | 'km' | 'mi'
export const allDistanceUnits: DistanceUnit[] = ['nmi', 'km', 'mi']

export type SpeedUnit = 'kn' | 'kph' | 'mph'
export const allSpeedUnits: SpeedUnit[] = ['kn', 'kph', 'mph']

export type DepthUnit = 'm' | 'ft'

export type TVesselSide = 'port' | 'stbd'
